<template>
    <div
        class="cursor-pointer text-gray-400 select-none flex gap-0.5"
        title="Klikk for å bytte mellom liten (S), medium (M) og stor (L) forhåndsvisning"
    >
        [
        <template
            v-for="(size, count) in attachmentPresetSizes"
            :key="size.name"
        >
            <span
                class="hover:text-primary"
                :class="{'text-primary': documentPreviewModalSize.name === size.name}"
                @click="onChangeDocumentPreviewModalSize(size)"
            >
                {{ size.name }}
            </span>
            <template v-if="count < 2">
                /
            </template>
        </template>
        ]
    </div>
</template>

<script setup lang="ts">
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import {attachmentPresetSizes} from '@/user-prefs/userPrefs.service'

const {documentPreviewModalSize, onChangeDocumentPreviewModalSize} = useDocumentPreviewModalService()

</script>

<style scoped>

</style>